// LOGICA LOGIN. La recuperación/cambio de contraseña quedó comentada por requerimiento del cliente.
import { IonIcon } from "@ionic/react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, Button, Card, CardContent, Divider, Link, Typography } from "@mui/joy";
import axios from "axios";
import { logoWhatsapp } from "ionicons/icons";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import CustomInput from "../../components/basicsComponents/CustomInput/CustomInput";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import { Column, Container, Row } from "../../components/basicsComponents/MaterialGridComponents";
import StyledButton from "../../components/basicsComponents/StyledButton/StyledButton";
// import ModalActualizarContrasena from "../../components/formComponents/ModalActualizarContrasena/ModalActualizarContrasena";
// import ModalCambioContraseña from "../../components/formComponents/ModalCambioContrasena/ModalCambioContrasena";
import ModalPacienteForm from "../../components/formComponents/ModalFormPaciente/ModalFormPaciente";
import ModalPrivacidad from "../../components/formComponents/ModalPrivacidad";
import useTituloPagina from "../../hooks/tituloPagina";

const LoginIonic = () => {
  const colorFondoSecundario = "var(--portal-surface)";
  const colorFondoSecundarioIntenso = "var(--portal-surface-strong)";
  const colorTextoPrincipal = "var(--portal-text-primary)";
  const colorAcento = "var(--portal-accent)";
  const colorAcentoOscuro = "var(--portal-accent-shade)";
  const [cargando, setCargando] = useState(false);
  const [blnVerPassword, setBlnVerPassword] = useState(false);
  const [usuario, setUsuario] = useState({
    usuario: "",
    password: "",
    token: "",
  });

  // Lógica de recuperación/cambio de contraseña desactivada en este repositorio.
  // const handleCloseModal = () => {
  //   setShowModal(false);
  // };

  // const [showModal, setShowModal] = useState(false);
  // const [attemptCount, setAttemptCount] = useState(0);
  //const [newPassword, setNewPassword] = useState("");
  //const [confirmPassword, setConfirmPassword] = useState("");
  const [urlAxioPP, setUrlAxio] = useState("");
  const [errorUsuario, setErrorUsuario] = useState(false);
  const [errorPassword, setErrorPassword] = useState(false);
  const [msjErrorPassword, setMsjErrorPassword] = useState("");
  const [registrarPaciente, setRegistrarPaciente] = useState(false);
  const [mostrarPrivacidad, setMostrarPrivacidad] = useState(false);
  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };

  const history = useHistory();
  useTituloPagina();

  const handleChangeVisibilityOfPassword = () => {
    setBlnVerPassword(!blnVerPassword);
  };

  useEffect(() => {
    setUrlAxio(localStorage.getItem("urlAxioPP"));

    document.title = localStorage.getItem("tituloWeb");
    sessionStorage.removeItem("ppUL");
  }, []);

  const loginPaciente = async (usuario, password) => {
    try {
      const response = await axios.post(`${urlAxioPP}Usuarios/LoginPaciente`, {
        nombreUsuario: usuario,
        password: password,
      });
      return response.data.token;
    } catch (error) {
      setErrorPassword(true);
      setMsjErrorPassword("Documento o contraseña incorrecto");
      mostrarNotificacion(true, "Error: " + error.response.data, "rojo");
    }
  };

  const obtenerPaciente = async (token, documento) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      const response = await axios.get(`${urlAxioPP}Pacientes?documento=${documento}`, config);
      const data = response.data[0];
      return {
        usuario: usuario.usuario,
        password: usuario.password,
        token: token,
        codigo: data.codigo,
        hc: data.hc,
        documentoNro: data.documentoNro,
        documentoTipo: data.documentoTipo,
        documentoTipoNombre: data.documentoTipoNombre,
        nombre: data.nombre,
        apellido: data.apellido,
        mutual: data.mutual,
        mutualNombre: data.mutualNombre,
        telefono: data.telefono,
        celular: data.celular,
        email: data.email,
        mutualAfiliado: data.mutualAfiliado,
        nacimiento: data.nacimiento,
      };
    } catch (error) {
      console.error("Error en petición obtenerPaciente", error.response);
      mostrarNotificacion(
        true,
        "Contraseña incorrecta o se produjo un error al intentar consultar los datos del paciente. Intente nuevamente",
        "rojo"
      );
    }
  };

  const handleClickSubmit = () => {
    setCargando(true);
    handleClickLogin(); // Llama directamente a la función de login sin validar si contraseña = documento
  };

  const handleClickLogin = async () => {
    setCargando(true);
    if (usuario.usuario !== "" && usuario.password !== "") {
      const token = await loginPaciente(usuario.usuario, usuario.password);
      const paciente = await obtenerPaciente(token, usuario.usuario);
      if (paciente) {
        mostrarNotificacion(true, "Sesión iniciada correctamente", "verde");
        setUsuario(paciente);
        sessionStorage.setItem("ppUL", JSON.stringify(paciente));
        history.push("/portal/Inicio", { justLogin: true });
      }
    } else {
      if (usuario.usuario !== "") setErrorUsuario(true);
      if (usuario.password !== "") {
        setErrorPassword(true);
        setMsjErrorPassword("Debe ingresar su contraseña");
      }
    }
    setCargando(false);
  };

  const handleChangeUsuario = (e) => {
    const value = e.target.value;
    //Reemplazamos los valores no numericos por espacios en blanco
    const filteredValue = value.replace(/[^0-9]+/g, "");
    setErrorUsuario(false);
    setUsuario({ usuario: filteredValue, password: usuario.password });
  };

  const handleChangePassword = (e) => {
    const value = e.target.value;
    setErrorPassword(false);
    setUsuario({ ...usuario, password: value });
  };

  // La validación y recuperación de contraseña quedó desactivada a pedido del cliente.
  // Si en el futuro se vuelve a requerir, esta era la lógica utilizada:
  // const handlePasswordChange = async () => {
  //   try {
  //     const response = await axios.post(`${urlAxioPP}/Usuarios/OlvideMiContrasenia`.replace(/([^:]\/)\/+/g, "$1"), {
  //       Documento: usuario.usuario,
  //       URL: "https://turnero.clinicadeojoscba.com/RecoveryPass/####",
  //       Mail: usuario.email,
  //     });
  //
  //     if (response.status === 200) {
  //       alert("Solicitud de cambio de contraseña enviada. Revisa tu email.");
  //       setShowModal(false);
  //       setAttemptCount(0);
  //     }
  //   } catch (error) {
  //     if (attemptCount < 2) {
  //       alert("Dirección de correo incorrecto o no existe en la base de datos. Intente nuevamente.");
  //       setAttemptCount(attemptCount + 1);
  //     } else {
  //       alert(
  //         "El mail ingresado es incorrecto. Debe comunicarse telefónicamente con Amprosa al 5493518150850 para actualizarlo. Caso contrario, NO podrá recuperar su contraseña. Será redirigido al inicio."
  //       );
  //       setShowModal(false);
  //       setAttemptCount(0);
  //       history.push("/Login");
  //     }
  //   }
  // };

  const handleClickCopiarTelefono = () => {
    const phoneNumber = "351-815-0850";
    navigator.clipboard.writeText(phoneNumber);

    mostrarNotificacion(true, "Se ha copiado el numero de telefono a su portapapeles", "");
  };

  return (
    <Container
      direction="column"
      alignItems="center"
      style={{
        minHeight: "100vh",
        width: "100%",
        padding: "20px 12px",
        background: `linear-gradient(90deg, rgba(16, 85, 28, 0) 25%, #10551c 100%), url(assets/fondo-login.jpg) top center / cover no-repeat`,
      }}
    >
      <Row
        container
        sx={{
          width: "100%",
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 1, sm: 2 },
          py: { xs: 1, sm: 2 },
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "420px",
            backgroundColor: colorFondoSecundario,
            borderRadius: { xs: "18px", sm: "24px" },
            p: { xs: 1.5, sm: 2 },
            boxShadow: "0 12px 28px rgba(var(--portal-accent-rgb), 0.12)",
          }}
        >
          <Card
            sx={{
              width: "100%",
              borderRadius: "14px",
              border: "1px solid rgba(var(--portal-accent-rgb), 0.10)",
              boxShadow: "0 8px 18px rgba(var(--portal-text-primary-rgb), 0.08)",
            }}
          >
          <CardContent>
            <Row container spacing={2} rowGap={2}>
              <Column xs={12}>
                <Box display="flex" justifyContent="center" mb={2}>
                  <img alt="Logo clinica" src="assets/logo-grande.png" style={{ width: "240px", height: "auto" }} />
                </Box>
                <Typography level="title-lg" align="center" sx={{ color: colorTextoPrincipal }}>
                  {"Portal del paciente".toUpperCase()}
                </Typography>
                <form noValidate autoComplete="off" style={{ marginBottom: "7.5px" }}>
                  <CustomInput
                    fullWidth
                    margin="normal"
                    value={usuario.usuario}
                    onChange={handleChangeUsuario}
                    error={errorUsuario}
                    sx={{ mb: 0.5 }}
                    startDecorator={
                      <Typography variant="plain" color="neutral" sx={{ width: "100px", color: colorTextoPrincipal }}>
                        Documento:
                      </Typography>
                    }
                  />

                  <CustomInput
                    fullWidth
                    margin="normal"
                    startDecorator={
                      <Typography variant="plain" color="neutral" sx={{ width: "100px", color: colorTextoPrincipal }}>
                        Contraseña:
                      </Typography>
                    }
                    endDecorator={
                      <React.Fragment>
                        <Divider orientation="vertical" />
                        <Button onClick={handleChangeVisibilityOfPassword} type="button" variant="plain" color="neutral">
                          {blnVerPassword ? <Visibility /> : <VisibilityOff />}
                        </Button>
                      </React.Fragment>
                    }
                    type={blnVerPassword ? "text" : "password"}
                    value={usuario.password}
                    onChange={handleChangePassword}
                    error={errorPassword}
                    helperText={
                      <React.Fragment>
                        <span>Ingrese su contraseña para continuar.</span>
                        <br />
                        {/*<Typography component="span" level="body2">
                          ¿Desea cambiar su contraseña?{" "}
                          <Link
                            component="button"
                            onClick={(e) => {
                              e.preventDefault();
                              setShowModal(true);
                            }}
                            underline="hover"
                            color="primary"
                          >
                            Haga click AQUI
                          </Link>
                        </Typography>*/}
                      </React.Fragment>
                    }
                    errorHelperText={msjErrorPassword}
                  />

                  <CustomInput
                    fullWidth
                    variant="solid"
                    color="neutral"
                    type="button"
                    onClick={handleClickSubmit}
                    disabled={cargando}
                    value={"Ingresar"}
                    inputSlotProps={{
                      style: {
                        color: "#FFFFFF",
                        border: "none",
                        fontWeight: 700,
                        letterSpacing: "0.02em",
                        cursor: "pointer",
                        textAlign: "center",
                        width: "100%",
                        WebkitAppearance: "none",
                        appearance: "none",
                      },
                    }}
                    sx={{
                      "--Input-paddingInline": "0px",
                      border: "none",
                      borderRadius: "8px",
                      backgroundColor: colorAcento,
                      "&:hover": {
                        backgroundColor: colorAcentoOscuro,
                      },
                      "& input": {
                        backgroundColor: "transparent",
                      },
                    }}
                  />
                </form>
                <Typography level="body-xs" paddingInline={1} sx={{ marginBottom: 1 }}>
                  {"Si es la primera vez que te vas a atender con nosotros, debes registrarte mediante nuestro WhatsApp."}
                </Typography>

                <Typography level="body-xs" paddingInline={1} sx={{ marginBottom: 1 }}>
                  Al registrarse acepta nuestra{" "}
                  <Link
                    href="/Privacidad"
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="hover"
                    color="neutral"
                    level="body-xs"
                    sx={{ color: colorTextoPrincipal }}
                  >
                    Política de Privacidad
                  </Link>
                </Typography>

                <StyledButton
                  className="verde"
                  expand="block"
                  fill="clear"
                  onClick={handleClickCopiarTelefono}
                  href={
                    "https://api.whatsapp.com/send?phone=+5493518150850&text=Hola%2C%20me%20ponía%20en%20contacto%20para%20registrarme%20como%20paciente."
                  }
                  target="_blank"
                >
                  <IonIcon icon={logoWhatsapp} />
                </StyledButton>

                <Typography level="body-xs" paddingInline={1} sx={{ marginTop: 1.25, textAlign: "center" }}>
                  ¿No es paciente?{" "}
                  <Link
                    component="button"
                    onClick={(event) => {
                      event.preventDefault();
                      setRegistrarPaciente(true);
                    }}
                    underline="hover"
                    color="primary"
                    level="body-xs"
                    sx={{ color: colorTextoPrincipal }}
                  >
                    REGÍSTRESE
                  </Link>
                </Typography>
              </Column>
            </Row>
          </CardContent>
          </Card>
        </Box>
      </Row>
      <Row container sx={{ width: "100%", justifyContent: "center", pt: 1 }}>
        <Link
          href="https://www.gacitua.com.ar/"
          rel="Proveedor del servicio noreferrer"
          target="_blank"
          sx={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}
        >
          <Typography level="title-lg">
            <Typography color="neutral"> {"Powered by "}</Typography>
            <img src={"assets/logoGacitua.png"} alt="logo gacitua y asociados" width={17} height={17} />
            <Typography> {" Gacitua & Asociados"}</Typography>
          </Typography>
        </Link>
      </Row>

      <ModalPacienteForm mostrarNotificacion={mostrarNotificacion} openModal={registrarPaciente} setOpenModal={setRegistrarPaciente} />

      <CustomToast
        openToast={toast.open}
        onDidDismiss={() => mostrarNotificacion(false, "", "")}
        message={toast.mensaje}
        colorNotificacion={toast.tipo}
      />

      {cargando && <LoadingBackdrop visualizar={cargando} />}

      {/* <ModalCambioContraseña
        isOpen={showModal}
        usuario={usuario}
        onClose={handleCloseModal}
        setUsuario={setUsuario}
        handlePasswordChange={handlePasswordChange}
        //onClose={() => setShowModal(false)}
      />

      <ModalActualizarContrasena /> */}

      <ModalPrivacidad abrirModal={mostrarPrivacidad} setAbrirModal={setMostrarPrivacidad} />
    </Container>
  );
};

export default LoginIonic;
